import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useConfiguratorContext } from '@/kenwood/configurator/context';
import { goHome } from '@/utils/Common/Redirects';
import Popup from '@/kenwood/configurator/components/Popup';

const PopupContent = ({ originHeader, onClose, t }) => {
  const history = useHistory();

  return (
    <div className='ken-configurator__generic-popup'>
      <button
        className='ken-configurator__generic-popup-close'
        type='button'
        onClick={onClose}
      >
        <img
          className='ken-configurator__generic-popup-close-img'
          src={`${DLG.config.distResourcePath}/assets/images/kenwood/configurator/close.svg`}
          alt={t('configurator:configurator.alt.close')}
        />
      </button>
      <div className='ken-configurator__generic-popup-content'>
        <img
          className='ken-configurator__generic-popup-alert-img'
          src={`${DLG.config.distResourcePath}/assets/images/kenwood/configurator/alert.svg`}
          alt='alert'
        />
        <div
          className='ken-configurator__generic-popup-title'
          dangerouslySetInnerHTML={{
            __html: t('configurator:configurator.changeconfig.popup.title'),
          }}
        />
        <div
          className='ken-configurator__generic-popup-desc'
          dangerouslySetInnerHTML={{
            __html: t(
              'configurator:configurator.changeconfig.popup.description',
            ),
          }}
        />
        <div className='ken-configurator__generic-popup-ctas'>
          <button
            className='ken-hero__textblock-cta ken-hero__textblock-cta--primary'
            type='button'
            onClick={onClose}
          >
            {t('configurator:configurator.changeconfig.popup.action.cancel')}
          </button>
          <button
            className='ken-hero__textblock-cta ken-hero__textblock-cta--secondary'
            type='button'
            onClick={() => {
              if (originHeader) {
                goHome();
              } else {
                onClose();
                history.push(
                  `${DLG.config.encodedContextPath}/configurator/step1`,
                );
              }
            }}
          >
            {t('configurator:configurator.changeconfig.popup.action.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

const ChangeConfigPopup = () => {
  const { t } = useTranslation();
  const [
    { changeConfigOpen },
    { setChangeConfigOpen },
  ] = useConfiguratorContext();
  return (
    <>
      <Popup isOpen={changeConfigOpen !== null}>
        <PopupContent
          originHeader={changeConfigOpen === 'header'}
          onClose={() => {
            setChangeConfigOpen(null);
          }}
          t={t}
        />
      </Popup>
    </>
  );
};

PopupContent.propTypes = {
  originHeader: PropTypes.bool,
  onClose: PropTypes.func,
  t: PropTypes.func,
};

PopupContent.defaultProps = {
  originHeader: false,
  onClose: () => {},
  t: () => {},
};

export default ChangeConfigPopup;
